import { removeStorageItem } from 'helpers/localStorage';
import { AppDispatch } from 'store';
import { globalOp, globalSlice } from 'store/global';

export const errorHandler = (error: any, dispatch: AppDispatch) => {
    const { statusCode, message } = error.data;
    const { setIsError } = globalSlice.actions;

    if (statusCode === 401) {
        dispatch(setIsError(true));
        removeStorageItem('access_token');
        window.location.pathname = '/';
        return null;
    }

    dispatch(globalOp.handleOpenSnackbar({ open: true, message, variant: 'error' }));
    return dispatch(setIsError(true));
};
